__turbopack_context__.v({
  "accordionSlideOverwrite": "checkbox-module-scss-module__8FHunG__accordionSlideOverwrite",
  "check": "checkbox-module-scss-module__8FHunG__check",
  "checkbox": "checkbox-module-scss-module__8FHunG__checkbox",
  "container": "checkbox-module-scss-module__8FHunG__container",
  "fadeIn": "checkbox-module-scss-module__8FHunG__fadeIn",
  "fadeOut": "checkbox-module-scss-module__8FHunG__fadeOut",
  "label": "checkbox-module-scss-module__8FHunG__label",
  "labelAfter": "checkbox-module-scss-module__8FHunG__labelAfter",
  "labelBefore": "checkbox-module-scss-module__8FHunG__labelBefore",
  "scaleIn": "checkbox-module-scss-module__8FHunG__scaleIn",
  "scaleOut": "checkbox-module-scss-module__8FHunG__scaleOut",
  "zoomIn": "checkbox-module-scss-module__8FHunG__zoomIn",
  "zoomOut": "checkbox-module-scss-module__8FHunG__zoomOut",
});
